import { getDefaultExportFromCjs } from '../../../../_virtual/_commonjsHelpers.js';
import { __module as unitless_cjs, exports as unitless_cjsExports } from '../../../../_virtual/unitless.cjs.js';
import { __require as requireUnitless_cjs_prod } from './unitless.cjs.prod.js';
import { __require as requireUnitless_cjs_dev } from './unitless.cjs.dev.js';
(function (module) {
  if (process.env.NODE_ENV === "production") {
    module.exports = requireUnitless_cjs_prod();
  } else {
    module.exports = requireUnitless_cjs_dev();
  }
})(unitless_cjs);
var unitless = /*@__PURE__*/getDefaultExportFromCjs(unitless_cjsExports);
export { unitless as default };
//# sourceMappingURL=unitless.cjs.js.map
